@if (status() === Status.VERIFIED) {
  <mat-icon class="text-[16px]! w-4! h-4! text-primary-9 shrink-0" matTooltip="Identité vérifiée">
    verified
  </mat-icon>
} @else if (status() === Status.REVIEW_REQUIRED) {
  <mat-icon
    class="text-[16px]! w-4! h-4! text-amber-10 shrink-0"
    matTooltip="Identité en attente de vérification admin"
  >
    hourglass_empty
  </mat-icon>
} @else if (status() === Status.FAILED) {
  <mat-icon class="text-[16px]! w-4! h-4! text-red-9 shrink-0" matTooltip="Identité rejetée">
    error
  </mat-icon>
}
